import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { token } from "@atlaskit/tokens";

import { SignupBackgroundLayout } from "@/components/signup/layouts";
import SiteActivation, { NewUser } from "@/components/signup/site-activation";
import { RovoDevAgentsLogo } from "@/components/signup/utils/get-rovo-dev-agents-logo";

import { CreateASiteHeading, PrivacyPolicy } from "../../components";

export const LoggedInDevAIFreeNewUser = () => {
    const intl = useIntl();

    const subHeaderText = intl.formatMessage({
        id: "siteActivation.loggedInDevAI.newUser",
        defaultMessage:
            "Sites are the shared space where people organize teams, work, and projects."
    });

    return (
        <SignupBackgroundLayout ProductLogo={<RovoDevAgentsLogo />}>
            <div css={containerCss}>
                <div css={headerGroupCss}>
                    <h1 css={headerCss}>
                        <span css={accentImageSpanCss}>
                            <CreateASiteHeading />
                        </span>
                    </h1>
                    <p css={headerCss}>{subHeaderText}</p>
                </div>
                <SiteActivation
                    NewUser={<NewUser PrivacyPolicy={<PrivacyPolicy />} />}
                />
            </div>
        </SignupBackgroundLayout>
    );
};

const containerCss = css({
    display: "flex",
    flexDirection: "column"
});

const headerGroupCss = css({
    display: "grid",
    gap: token("space.100")
});

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

const accentImageSpanCss = css({
    position: "relative"
});
